import Link from "next/link";

export const metadata = { title: "Theme Preview · Admin" };
export const dynamic = "force-dynamic";

const MOCKUPS = [
  {
    slug: "a",
    name: "Quiet Editorial",
    tagline: "Aeon · The Atlantic · The Drift",
    description:
      "Tạp chí trầm. Hero không ảnh — chỉ chữ Fraunces khổng lồ làm tuyên ngôn. Drop-cap. Italic standfirst Newsreader. Whitespace cực rộng. Một accent đồng. Đọc nghiêm túc, dài, suy ngẫm.",
    bg: "#FBF8F0",
    fg: "#1A1410",
    accent: "#9C6B2A",
    swatches: ["#FBF8F0", "#F4EDDC", "#9C6B2A", "#1A1410"],
  },
  {
    slug: "b",
    name: "Cinema Magazine",
    tagline: "WIRED feature · Bloomberg Originals · Polygon longform",
    description:
      "Điện ảnh. Hero ảnh full-bleed cao 92vh, masthead overlay trên ảnh, gradient từ trên xuống. Mosaic asymmetric với roman numeral khổng lồ làm marker section. Pull-quote 56px italic giữa nền đen. Ấn tượng visual mạnh.",
    bg: "#0B0B0C",
    fg: "#F4EFE3",
    accent: "#E8B86A",
    swatches: ["#0B0B0C", "#1f1c17", "#E8B86A", "#F4EFE3"],
  },
  {
    slug: "c",
    name: "Swiss Grid Newsroom",
    tagline: "FT · Reuters · Bloomberg Terminal",
    description:
      "Tin tức chuyên nghiệp. Sans-only Manrope grotesk weight 800. Strict 12-col grid với hairline rules. Density vừa phải, eyebrow uppercase mono đỏ. Market data strip nền đen. Đọc nhanh, tra cứu nhanh.",
    bg: "#F0EDE6",
    fg: "#0E1116",
    accent: "#C73E1D",
    swatches: ["#F0EDE6", "#FFFFFF", "#C73E1D", "#0E1116"],
  },
  {
    slug: "d",
    name: "Terminal Live",
    tagline: "Bloomberg Terminal × Polymarket × Perplexity",
    description:
      "Phá khỏi paradigm báo điện tử. Đây không phải tờ báo — là trading desk live. Ticker tape kéo dài đầu trang, AI Briefing card có cited sources và follow-up prompts, sector heatmap màu green/red, wire feed log chronological, watchlist sidebar, deep-dive numbered. Mono everywhere, nền đen tinh, accent green #00D67A. Đột phá vì nó từ chối là website tin tức.",
    bg: "#0A0B0E",
    fg: "#E8ECF1",
    accent: "#00D67A",
    swatches: ["#0A0B0E", "#0F1115", "#00D67A", "#22D3EE"],
  },
  {
    slug: "e",
    name: "Conversational AI",
    tagline: "Perplexity Finance × ChatGPT × Arc Browser",
    description:
      "Trang chính là một cuộc hội thoại, không phải tờ báo. Centerpiece là prompt box khổng lồ. AI sinh briefing dạng chat-stream với sup citations [1] [2], sources card, follow-up prompts. Articles xuất hiện như result cards. Conic-gradient avatar AI, nền slate đen, accent mint #A1FFCB.",
    bg: "#0E0E10",
    fg: "#F5F5F7",
    accent: "#A1FFCB",
    swatches: ["#0E0E10", "#1A1A1F", "#A1FFCB", "#B794F4"],
  },
  {
    slug: "f",
    name: "Brutalist",
    tagline: "Are.na · Kanye.com · Bloomberg 1996 · Yale School of Art",
    description:
      "Anti-design. Headlines 200px nhảy lung tung, overlap. Mono everywhere. Đen trắng tuyền + 1 accent Klein blue #0017FF. Wall of posts dạng table HTML thô, manifesto block đỏ son thành blue, ASCII section dividers. Cảm giác như site không được thiết kế — được gõ ra. Đột phá vì nó từ chối là 'đẹp'.",
    bg: "#FFFFFF",
    fg: "#000000",
    accent: "#0017FF",
    swatches: ["#FFFFFF", "#000000", "#0017FF", "#FF0000"],
  },
  {
    slug: "g",
    name: "Almanac Việt Nam",
    tagline: "Lịch vạn niên · Tử vi xưa · Tạp chí Phong Hóa",
    description:
      "Bản địa Việt Nam thật sự. Giấy dó kem, đỏ son #B5251F, vàng đồng #A88234, đen mực tàu. Masthead 'Tài Lộc Báo' Fraunces WONK italic. Daily almanac strip với Hoàng Đạo + Tài Thần + ngày Can Chi. Tử vi tài chính 12 con giáp dạng table. Đối liên (couplet) trên nền đỏ son. Vermillion seal (con dấu) ở hero. Đột phá vì nó là Việt Nam, không phải editorial Tây Việt hóa.",
    bg: "#F1E8D0",
    fg: "#1A0F08",
    accent: "#B5251F",
    swatches: ["#F1E8D0", "#B5251F", "#A88234", "#1A0F08"],
  },
];

export default function PreviewIndex() {
  return (
    <div className="max-w-5xl mx-auto py-6">
      <h1 className="font-display text-2xl mb-2">7 Mockup design preview</h1>
      <p className="text-sm text-ink-muted mb-8">
        7 hướng thiết kế hoàn toàn khác paradigm. A/B/C đi theo trường phái editorial publication.
        D/E/F/G phá khỏi paradigm tờ báo: D=trading desk, E=AI conversation, F=brutalist anti-design,
        G=almanac Việt Nam bản địa. Click vào từng cái để xem live homepage.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {MOCKUPS.map((m) => (
          <Link
            key={m.slug}
            href={`/admin/theme/preview/${m.slug}`}
            target="_blank"
            className="group block rounded-xl overflow-hidden border-2 border-stroke-subtle hover:border-accent-primary transition"
          >
            <div
              className="aspect-[16/9] relative p-6 flex flex-col justify-between"
              style={{ background: m.bg, color: m.fg }}
            >
              <div className="text-[10px] uppercase tracking-[0.3em] font-mono opacity-70">
                Mockup {m.slug.toUpperCase()}{(m.slug === "d" || m.slug === "e" || m.slug === "f" || m.slug === "g") ? " · NEW" : ""}
              </div>
              <div>
                <div
                  className="text-[10px] uppercase tracking-[0.25em] mb-2 font-bold"
                  style={{ color: m.accent }}
                >
                  {m.tagline}
                </div>
                <div
                  className="text-3xl leading-[1.05] font-medium"
                  style={{
                    fontFamily:
                      m.slug === "c" ? "var(--font-manrope)" :
                      m.slug === "d" || m.slug === "f" ? "var(--font-jetbrains-mono)" :
                      "var(--font-fraunces)",
                    fontWeight: m.slug === "c" || m.slug === "f" ? 800 : (m.slug === "d" ? 700 : 500),
                    letterSpacing: m.slug === "d" || m.slug === "f" ? "-0.04em" : undefined,
                    fontStyle: m.slug === "g" ? "italic" : "normal",
                  }}
                >
                  {m.name}
                </div>
              </div>
              <div className="flex gap-1.5">
                {m.swatches.map((c, i) => (
                  <div key={i} className="w-6 h-6 rounded-full border" style={{ background: c, borderColor: "rgba(0,0,0,0.1)" }} />
                ))}
              </div>
            </div>
            <div className="p-5 bg-bg-elevated/40">
              <p className="text-sm text-ink-secondary leading-relaxed mb-3">{m.description}</p>
              <div className="text-[12px] uppercase tracking-wider font-mono text-accent-primary group-hover:underline">
                Xem live → /admin/theme/preview/{m.slug}
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-10 pt-6 border-t border-stroke-subtle text-sm text-ink-muted">
        Đã chọn? Trả lời lại Carla bằng chữ A / B / C.
      </div>
    </div>
  );
}
